<template>
  <div class="dialog-callback">
  </div>
</template>

<script>
export default {
  name: 'DialogQRCallback',
  data () {
    return {
    }
  },
  created () {
    let param = this.$route.query || {};
    let code = param.code;
    if (code) {
      //官网弹窗登录,postmessage
      window.top.postMessage({
        'type': 'authsuccess',    // 自定义事件名               
        'value': code // 数据，只能是字符串
      }, '*');
    }
  }
}
</script>

<style lang="scss">
.dialog-callback {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ffffff;
  justify-content: center;
}
</style>